import { ILocationInput } from 'types/graphqlTypes'
import { TStopSchema } from '../schema/ShipmentSchema/StopSchema'

export const getLocationInput = (stops: TStopSchema[]): ILocationInput[] => {
  let locations: ILocationInput[] = []
  stops.forEach(({ shipperFacility }) => {
    const { address, city, id: shipperFacilityId, stateCode } = shipperFacility || {}
    if (shipperFacilityId && Boolean(address || city || stateCode)) {
      locations = [
        ...locations,
        {
          address,
          city,
          stateCode,
        },
      ]
    }
  })
  return locations
}
